import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchPrices } from "../api/prices.api";

const usePrices = ({ year }: { year: number }) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const { data, error, isLoading } = useQuery({
    queryKey: ["prices", year],
    queryFn: () => fetchPrices(bearerToken as string, year),
  });

  return {
    pricesData: data,
    error,
    isLoading,
  };
};

export default usePrices;
